import { render, staticRenderFns } from "./dashboardView.vue?vue&type=template&id=b6efc666&scoped=true&"
import script from "./dashboardView.vue?vue&type=script&lang=js&"
export * from "./dashboardView.vue?vue&type=script&lang=js&"
import style0 from "./dashboardView.vue?vue&type=style&index=0&id=b6efc666&prod&lang=scss&scoped=true&"
import style1 from "./dashboardView.vue?vue&type=style&index=1&id=b6efc666&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6efc666",
  null
  
)

export default component.exports